<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/TransferBarcodeMultiple'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">ตัวแทนจำหน่าย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbOriginAgentCode'"
                    :name="'reTbOriginAgentCode'"
                    :select2-options="reTbOriginAgentCodeOptions"
                    @selectChange="onOriginAgentCodeChange"
                    v-model="reTbOriginAgentCode"
                    ref="reTbOriginAgentCode"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">ร้านค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbDestinationShopCode'"
                    :name="'reTbDestinationShopCode'"
                    :select2-options="reTbDestinationShopCodeOptions"
                    multiple
                    v-model="reTbDestinationShopCode"
                  ></select2> -->

                  <treeselect
                    v-model="reTbDestinationShopCode"
                    :async="true"
                    :multiple="true"
                    :load-options="LoadreTbDestinationShopCodeOptions"
                    v-on:open="reLoadTbDestinationShopCodeOptions"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                    ref="reTbDestinationShopCode"
                  />
                </div>
              </div>

              <!-- <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label"
                    >ชื่อร้านค้า(กรณีไม่มีรหัสร้านค้า):</label
                  >
                  <input
                    v-model="reTbDestinationShopName"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุชื่อร้านค้า(กรณีไม่มีรหัสร้านค้า)"
                  />
                </div>
              </div> -->

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>อำเภอ:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbAmpherId'"
                    :name="'reTbAmpherId'"
                    :select2-options="reTbAmpherIdOptions"
                    v-model="reTbAmpherId"
                    multiple
                    ref="reTbAmpherIdSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reTbAmpherId"
                    :multiple="true"
                    :options="reTbAmpherIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>BARCODE:</label>
                  <input
                    v-model="reTbBarcode"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>รหัสทรัพย์สิน(เบียร์สด):</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbDepartmentMaterialCode'"
                    :name="'reTbDepartmentMaterialCode'"
                    :select2-options="reTbDepartmentMaterialCodeOptions"
                    multiple
                    v-model="reTbDepartmentMaterialCode"
                  ></select2> -->

                  <treeselect
                    v-model="reTbDepartmentMaterialCode"
                    :multiple="true"
                    :load-options="LoadreTbDepartmentMaterialCodeOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbProductTypeId'"
                    :name="'reTbProductTypeId'"
                    :select2-options="reTbProductTypeIdOptions"
                    multiple
                    v-model="reTbProductTypeId"
                  ></select2> -->
                  <treeselect
                    v-model="reTbProductTypeId"
                    :multiple="true"
                    :options="reTbProductTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbBrandId'"
                    :name="'reTbBrandId'"
                    :select2-options="reTbBrandIdOptions"
                    multiple
                    v-model="reTbBrandId"
                  ></select2> -->
                  <treeselect
                    v-model="reTbBrandId"
                    :multiple="true"
                    :options="reTbBrandIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbAssetCode'"
                    :name="'reTbAssetCode'"
                    :select2-options="reTbAssetCodeOptions"
                    multiple
                    v-model="reTbAssetCode"
                  ></select2> -->
                  <treeselect
                    v-model="reTbAssetCode"
                    :multiple="true"
                    :options="reTbAssetCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>จำนวนวันคงค้าง:</label>
                  <input
                    v-model="reTbOccupiedDays"
                    type="number"
                    class="form-control"
                    placeholder="กรุณาระบุจำนวนวันคงค้าง"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbReturnStatus'"
                    :name="'reTbReturnStatus'"
                    :select2-options="reTbReturnStatusOptions"
                    v-model="reTbReturnStatus"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button
                  v-if="
                    this.$root.canShow(['AGENT_REPORT', 'SUB_AGENT_REPORT'])
                  "
                  class="btn btn-outline-primary"
                  @click="exportTransferBarcode"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>

                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reTbIsSelectAgent: false,
      reTbIsInitial: true,
      reTbOriginAgentCode: null,
      reTbDestinationShopCode: [],
      reTbDestinationShopName: null,
      reTbAmpherId: [],
      reTbBarcode: null,
      reTbDepartmentMaterialCode: [],
      reTbNFCCode: [],
      reTbProductTypeId: [],
      reTbAssetCode: [],
      reTbBrandId: [],
      reTbOccupiedDays: null,
      reTbReturnStatus: null,
      reTbAmpherIdOptions: [],
      reTbDestinationShopCodeOptions: [],
      reTbDestinationShopCodeOptionsData: [],
      // reTbAmpherIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterLocation/Select2SearchAmpher",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         agentCode: self.reTbOriginAgentCode,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },

      reTbOriginAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
      // reTbDestinationShopCodeOptions: {
      //   placeholder: "กรุณาเลือกร้านค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Shop/Select2ShopByAgent",
      //     data: function(params) {
      //       var query = {
      //         agentCode: self.reTbOriginAgentCode,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbBarcodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reTbDepartmentMaterialCodeOptions: [],
      // reTbDepartmentMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสสินทรัพย์",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2DepartmentMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbNFCCodeOptions: [],
      // reTbNFCCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกNFC",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2NFC",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbProductTypeIdOptions: [],
      // reTbProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbBrandIdOptions: [],
      //  reTbBrandIdOptions: {
      //     minimumResultsForSearch: -1,
      //     placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //     ajax: {
      //       url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //       data: function(params) {
      //         var query = {
      //           search: params.term,
      //           page: params.page || 1,
      //         };
      //         return query;
      //       },
      //       processResults: function(data, params) {
      //         return {
      //           results: data.results,
      //           pagination: {
      //             more: data.more,
      //           },
      //         };
      //       },
      //       transport: function(params, success, failure) {
      //         params.beforeSend = function(request) {
      //           request.setRequestHeader(
      //             "Authorization",
      //             "Bearer " + self.$root.user.access_token
      //           );
      //         };
      //         var $request = $.ajax(params);
      //         $request.then(success);
      //         $request.fail(failure);
      //         return $request;
      //       },
      //     },
      //   },
      reTbAssetCodeOptions: [],
      // reTbAssetCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbReturnStatusOptions: {
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        data: [
          {
            id: "ยังไม่ได้ส่งคืน",
            text: "ยังไม่ได้ส่งคืน",
          },
          {
            id: "ส่งคืนแล้ว",
            text: "ส่งคืนแล้ว",
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;

      self.reTbOriginAgentCode = null;
      self.reTbDestinationShopCode = [];
      self.reTbDestinationShopName = null;
      self.reTbBarcode = null;
      self.reTbDepartmentMaterialCode = [];
      self.reTbNFCCode = [];
      self.reTbProductTypeId = [];
      self.reTbAssetCode = [];
      self.reTbBrandId = [];
      self.reTbOccupiedDays = null;
      self.reTbReturnStatus = null;
      self.reTbAmpherId = [];

      $("#reTbAmpherId")
        .empty()
        .trigger("change");

      $("#reTbOriginAgentCode")
        .empty()
        .trigger("change");

      $("#reTbDestinationShopCode")
        .empty()
        .trigger("change");

      $("#reTbBarcode")
        .val("")
        .trigger("change");

      $("#reTbDepartmentMaterialCode")
        .val("")
        .trigger("change");

      $("#reTbProductTypeId")
        .val("")
        .trigger("change");

      $("#reTbAssetCode")
        .val("")
        .trigger("change");

      $("#reTbBrandId")
        .val("")
        .trigger("change");

      $("#reTbReturnStatus")
        .val("")
        .trigger("change");

      self.initSelectedAgent();
    },
    formSubmit: function(e) {
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      if (
        self.reTbDestinationShopCode.length == 0 &&
        !self.reTbDestinationShopName &&
        self.reTbAmpherId.length == 0
      ) {
        // Swal.fire(
        //   "เกิดข้อผิดพลาด",
        //   "กรุณาเลือกหรือระบุร้านค้าหรือเลือกอำเภอ",
        //   "warning"
        // );
        // return false;
      } else {
        let criterias = 0;
        if (self.reTbDestinationShopCode.length != 0) criterias++;
        if (self.reTbDestinationShopName) criterias++;
        if (self.reTbAmpherId.length != 0) criterias++;

        if (criterias > 1) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "กรุณาเลือกหรือระบุร้านค้าหรือเลือกอำเภออย่างใดอย่างหนึ่ง",
            "warning"
          );
          return false;
        }
      }

      e.preventDefault();
    },
    onOriginAgentCodeChange: function(id, text, data, ref) {
      var self = this;

      self.reTbDestinationShopCode = [];
      self.reTbAmpherId = [];
      self.LoadreTbAmpherIdOptions();
    },
    initSelectedAgent: function(e) {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดำเนินการ กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/Select2Agent",
        data: {
          search: null,
          page: 1,
          province_id: [],
          department: [],
          AgentCodes: [],
        },
      })
        .then(function(response) {
          if (response.data != []) {
            self.$refs.reTbOriginAgentCode.setSelectedData({
              id: response.data.results[0].id,
              text: response.data.results[0].text,
            });
          } else {
            //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    exportTransferBarcode: function(e) {
      e.preventDefault();
      let self = this;

      if ( self.reTbOriginAgentCode.length == 0)
      {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุตัวแทนจำหน่าย", "warning");
        return false;
      }

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }
      if (
        self.reTbDestinationShopCode.length == 0 &&
        !self.reTbDestinationShopName &&
        self.reTbAmpherId.length == 0
      ) {
        // Swal.fire(
        //   "เกิดข้อผิดพลาด",
        //   "กรุณาเลือกหรือระบุร้านค้าหรือเลือกอำเภอ",
        //   "warning"
        // );
        // return false;
      } else {
        let criterias = 0;
        if (self.reTbDestinationShopCode.length != 0) criterias++;
        if (self.reTbDestinationShopName) criterias++;
        if (self.reTbAmpherId.length != 0) criterias++;

        if (criterias > 1) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "กรุณาเลือกหรือระบุร้านค้าหรือเลือกอำเภออย่างใดอย่างหนึ่ง",
            "warning"
          );
          return false;
        }
      }

      if (self.reTbDestinationShopCode.length > 255) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกร้านค้าไม่เกิน 255 ร้านค้า",
          "warning"
        );
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportTransferBarcodeMultiple",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reTbIsInitial,
          OriginAgentCode: self.reTbOriginAgentCode,
          DestinationShopCode: self.reTbDestinationShopCode,
          AmpherId: self.reTbAmpherId,
          Barcode: self.reTbBarcode,
          DepartmentMaterialCode: self.reTbDepartmentMaterialCode,
          NFCCode: self.reTbNFCCode,
          ProductTypeId: self.reTbProductTypeId,
          AssetCode: self.reTbAssetCode,
          BrandId: self.reTbBrandId,
          OccupiedDays: self.reTbOccupiedDays,
          ReturnStatus: self.reTbReturnStatus,
          DestinationShopName: self.reTbDestinationShopName,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          // Swal.fire("เกิดข้อผิดพลาด", "จำนวนร้านค้าเกิน 255 รายการ", "error");
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreTbAmpherIdOptions: function(e) {
      var self = this;
      axios
        .post("/Api/MasterLocation/Select2SearchAmpher", {
          agentCode: self.reTbOriginAgentCode,
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            self.reTbAmpherIdOptions = [];
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbAmpherIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    // LoadreTbDestinationShopCodeOptions({ action, searchQuery, callback }) {
    LoadreTbDestinationShopCodeOptions( inputdata = null ) {
      var self = this;
      if (inputdata) {
        if (inputdata.action === ASYNC_SEARCH) {
          axios
          .get("/Api/Shop/Select2ShopByAgent", {
            params: {
              agentCode: self.reTbOriginAgentCode,
              page: 1,
              all: true,
              search: inputdata.searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              const options = [];
              data.forEach((element) => {
                options.push({
                  id: element.id,
                  label: element.text,
                });
              });
              inputdata.callback(null, options);
            }
          });
        }
      }
    },
    reLoadTbDestinationShopCodeOptions( inputdata = null ) {
      this.$refs.reTbDestinationShopCode.trigger.searchQuery = null;
    },
    LoadreTbDepartmentMaterialCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reTbDepartmentMaterialCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2DepartmentMaterial", {
            params: {
              agentCode: self.reTbOriginAgentCode,
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reTbDepartmentMaterialCodeOptions = [];
              data.forEach((element) => {
                self.reTbDepartmentMaterialCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reTbDepartmentMaterialCodeOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreTbNFCCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reTbNFCCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2NFC", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reTbNFCCodeOptions = [];
              data.forEach((element) => {
                self.reTbNFCCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reTbNFCCodeOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreTbProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreTbBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreTbAssetCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbAssetCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;
    self.initSelectedAgent();
    self.LoadreTbAmpherIdOptions();
    self.LoadreTbProductTypeIdOptions();
    self.LoadreTbBrandIdOptions();
    self.LoadreTbAssetCodeOptions();
    // self.LoadreTbDestinationShopCodeOptions();

    $(self.$refs.form).validate({
      ignore: ":hidden, .ignore",
      rules: {
        reTbOriginAgentCode: "required",
      },
      messages: {
        reTbOriginAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/TransferBarcodeMultiple.vue